import { gql } from "@apollo/client";

export const sweepstakesQuery = gql`
  query RedirectReceiptSweepstakesQuery($id: SweepstakesSlug!) {
    sweepstakes(id: $id) {
      id
      googleAdsConversionId
      activeSponsorCampaign {
        id
        url
        smallImage {
          publicId
          version
          cloudName
        }
        largeImage {
          publicId
          version
          cloudName
        }
      }
      activeThankYouCampaign {
        id
        smallImageUrl
        largeImageUrl
        promoCode {
          id
          name
        }
      }

      nonprofit {
        id
        ein
        name
        paymentAccountId
        profile {
          color
        }
      }
    }
  }
`;

export const receiptQuery = gql`
  query RedirectReceiptQuery($id: ID!) {
    receipt(id: $id) {
      id
      rewardTicketCount
      promoCodeTicketCount

      ticketRanges {
        min
        max
      }

      donationLevel {
        id
        level
        price
        rewardTickets
      }

      donor {
        firstName
        lastName
        email
        phone
        address {
          line1
          line2
          city
          state
          postalCode
          country
        }
      }
    }
  }
`;
